const phoneValidation = (phoneNumber) => {
    const israeliPhoneRegex = /^05\d{8}$/;

    return israeliPhoneRegex.test(phoneNumber) && phoneNumber.length === 10;
};

export default phoneValidation;
